import { render } from "./UxWrapper.vue?vue&type=template&id=54d74081"
import script from "./UxWrapper.vue?vue&type=script&lang=js"
export * from "./UxWrapper.vue?vue&type=script&lang=js"

import "./UxWrapper.vue?vue&type=style&index=0&id=54d74081&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__